import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

export const ButtonMui = styled(Button)({
    color: '#fff',
    textTransform: 'none',

    '.MuiButton-endIcon': {
        pointerEvents: 'none',
    },
})
